import { IUpdateTenantOrganisationPayload } from '@pharvio/core/shared';

export class LoadTenantOrganisation {
  static readonly type = '[TenantOrganisation] Load';
}

export class UpdateTenantOrganisation {
  static readonly type = '[TenantOrganisation] Update';
  constructor(public payload: IUpdateTenantOrganisationPayload) {}
}
